angular.module("requestDataAnagSoc.components", []).component("requestDataAnagSoc", {
    templateUrl: "ng/components/variazioneAnagSoc/requestDataAnagSoc/requestDataAnagSoc.view.html",
    bindings: {
        richiestePostVendita: "=",
        exportValidityRequest: "&"
    },
    controllerAs: "requestDataAnagSocCtrl",
    controller: function VariazioneDataAnagSoc(
        $location,
        $userService,
        $typeDomainService,
        $portalService,
        Sede
    ) {
        var self = this;

        self.$onInit = function () {
            self.$portalService = $portalService;
            self.supportModel = {
                variazioneAnagrafica: "",
                formeGiuridicheList: [],
                formaGiuridicaSelected: [],
                endSearchRest: false
            }

            self.supportModel.variazioneAnagrafica = self.richiestePostVendita.metadata.variazioneAnagrafica;

            getInfoAnagrafiche();
            getAllFormeGiuridiche();

        };

        self.handleChange = function (property, value) {
            switch (property) {
                case "sedeLegale":
                    self.supportModel.variazioneAnagrafica[property] = value;
                    break;
                default:
                    self.supportModel.variazioneAnagrafica[property] = value;
                    break;
            }

            self.checkFields();
        }

        self.checkSede = function (validity) {
            self.sedeIsOk = validity;
            self.checkFields();
        }

        self.checkFields = function () {
            var variazioneSocietaria = self.supportModel.variazioneAnagrafica.ragioneSociale && self.supportModel.variazioneAnagrafica.formaGiuridica &&
                self.supportModel.variazioneAnagrafica.cf && self.supportModel.variazioneAnagrafica.piva &&
                self.supportModel.variazioneAnagrafica.emailPec && self.sedeIsOk;

            if (variazioneSocietaria) {
                self.richiestePostVendita.metadata.variazioneAnagrafica = self.supportModel.variazioneAnagrafica;
                self.enableConfirm(true);
            } else {
                self.enableConfirm(false);
            }
        }

        self.back = function () {
            $location.path("/");
        }

        self.enableConfirm = function (validity) {
            self.exportValidityRequest({
                validity
            })
        }

        var getAllFormeGiuridiche = function () {
            $typeDomainService.getDomainSet("CERVED_TO_NSIL", "FORMA_GIURIDICA").then(function (response) {
                self.supportModel.formeGiuridicheList = response.domainList;
            });
        };

        var getInfoAnagrafiche = function () {
            self.startLoader = true;
            var variazioneAnagrafica = self.richiestePostVendita.metadata.variazioneAnagrafica;

            var isOk = Sede.build(self.supportModel.variazioneAnagrafica.sedeLegale).isOk(false, true);
            var varAnagSoc = Boolean(variazioneAnagrafica.ragioneSociale && variazioneAnagrafica.formaGiuridica &&
                variazioneAnagrafica.cf && variazioneAnagrafica.piva);

            if (isOk && varAnagSoc) {
                self.supportModel.formaGiuridicaSelected.name = variazioneAnagrafica.formaGiuridica
                self.supportModel.endSearchRest = !self.supportModel.endSearchRest;
                self.startLoader = false;
            } else {

                $userService.getInfoAnagrafiche()
                    .then(function (user) {
                        if (user && user.metadata && user.metadata.riUserG) {
                            self.supportModel.variazioneAnagrafica.ragioneSociale = variazioneAnagrafica.ragioneSociale ? variazioneAnagrafica.ragioneSociale : user.metadata.riUserG.ragioneSociale;
                            self.supportModel.variazioneAnagrafica.formaGiuridica = variazioneAnagrafica.formaGiuridica ? variazioneAnagrafica.formaGiuridica : user.metadata.riUserG.formaGiuridica;
                            self.supportModel.formaGiuridicaSelected.name = variazioneAnagrafica.formaGiuridica.name ? variazioneAnagrafica.formaGiuridica.name : user.metadata.riUserG.formaGiuridica;
                            self.supportModel.variazioneAnagrafica.cf = variazioneAnagrafica.cf ? variazioneAnagrafica.cf : user.metadata.riUserG.cf;
                            self.supportModel.variazioneAnagrafica.piva = variazioneAnagrafica.piva ? variazioneAnagrafica.piva : user.metadata.riUserG.piva;
                            self.supportModel.variazioneAnagrafica.emailPec = variazioneAnagrafica.emailPec ? variazioneAnagrafica.emailPec : user.metadata.riUserG.emailPec;

                            if (isOk) {
                                self.supportModel.variazioneAnagrafica.sedeLegale = Sede.build(variazioneAnagrafica.sedeLegale);
                                self.supportModel.variazioneAnagrafica.sedeLegale.luogoEsteso.nome = variazioneAnagrafica.sedeLegale.comune;
                            } else {
                                self.supportModel.variazioneAnagrafica.sedeLegale = Sede.build(user.metadata.riUserG.sedeLegale);
                                self.supportModel.variazioneAnagrafica.sedeLegale.luogoEsteso.nome = user.metadata.riUserG.sedeLegale.comune;
                            }
                            self.supportModel.endSearchRest = !self.supportModel.endSearchRest;

                            self.startLoader = false;
                        }
                    }).finally(function () {
                        self.startLoader = false;
                    })

            }
        }
    }
});